export function randomString(): string {
    return Math.random().toString(36).substring(2, 15);
}

/*
guid(): string {
    // Came from https://gist.github.com/jed/982883, so let's not eslint it
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // tslint:disable-next-line
      const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}
*/